// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"m7-z"};